import { useRef, useEffect } from "react"
import React from "react"
import { useNavigate } from "react-router-dom";

//Note :
// While creating "dist" folder for deployement , replace  "import.meta.env.VITE_BASE_URL" with the actual API base URL for UAT or PROD environment
//Replace the Base url with below one , if you are moving dist folder to UAT or PROD
// UAT Leave URL : https://uatdcrapi.kea-sfe.com
// Prod Leave URL :https://prodleave.kea-sfe.com

const BASE_URL = import.meta.env.VITE_LEAVE_BASE_URL

function LeaveApproval() {
  const iframeRef = useRef(null)
  const navigate = useNavigate()

  useEffect(() => {
    const handler = (event) => {
      if (event.origin !== `${BASE_URL}`) return
       // Handle navigation message from the leave module
      if (event.data?.type === "NAVIGATE_HOME") {
          navigate("/home"); // or whatever parent route
        }
      if (event.data?.type !== "LEAVE_READY") return

      // Leave module listener is now registered — safe to send
      const userData = JSON.parse(localStorage.getItem("userData"))

      iframeRef.current?.contentWindow.postMessage(
        {
          type: "INIT_USER",
          payload: userData,
          apiBaseUrl: import.meta.env.VITE_BASE_URL,
          appname: "Expense",
        },
        `${BASE_URL}`
      )
    }

    window.addEventListener("message", handler)
    return () => window.removeEventListener("message", handler)
  }, [navigate])

  return (
    <div className="iframe-wrapper">
      <iframe
        ref={iframeRef}
        src={`${BASE_URL}/#/leaveApproval`}
        title="Leave"
        className="leave-iframe"
      />
    </div>
  )
}

export default LeaveApproval
